import { render } from "./choose-goods.vue?vue&type=template&id=2ff8030c&scoped=true&ts=true"
import script from "./choose-goods.vue?vue&type=script&lang=ts"
export * from "./choose-goods.vue?vue&type=script&lang=ts"

import "./choose-goods.vue?vue&type=style&index=0&id=2ff8030c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff8030c"]])

export default __exports__